import React from "react";

const TextAreaField = React.forwardRef<
	HTMLTextAreaElement,
	{
		className?: string;
		errorMessage?: string;
		rows?: number;
		label?: string;
		helpText?: string;
		placeholder?: string;
		readOnly?: boolean;
		optionalLabel?: boolean;
		customGrayOnDisable?: boolean;
		noBorderRadius?: boolean;
		grayBorder?: boolean;
	}
>(
	(
		{
			className,
			errorMessage,
			rows,
			label,
			helpText,
			placeholder,
			readOnly,
			optionalLabel,
			customGrayOnDisable,
			noBorderRadius,
			grayBorder,
			...otherProps
		},
		ref,
	) => {
		return (
			<div className={`w-full space-y-1 ${className}`}>
				{label && (
					<label className=" text-sm font-bold">
						{label} {optionalLabel && <span className="text-xs font-semibold text-gray-700">(Optional)</span>}
					</label>
				)}
				{errorMessage && <p className="text-xs font-medium text-red-500">{errorMessage}</p>}
				{helpText && <p className="my-2 text-xs text-gray-500">{helpText}</p>}
				<textarea
					{...otherProps}
					ref={ref}
					rows={rows}
					readOnly={readOnly}
					placeholder={placeholder}
					className={`flex w-full items-center ${noBorderRadius ? "rounded-0" : "rounded-md"} border ${
						grayBorder ? "!border-opacity-1 border-2 !border-gray-300 bg-white" : ""
					} bg-gray-50 px-2 focus:border-transparent focus:outline-none focus:ring-2 ${className} ${
						errorMessage
							? "border-red-500 focus:ring-red-500"
							: `${!grayBorder ? "!border-gray-400" : ""} focus:ring-secondary`
					} ${customGrayOnDisable ? "read-only:bg-warmGray-200" : ""}  `}
				/>
			</div>
		);
	},
);

TextAreaField.displayName = "TextAreaField";
export default TextAreaField;
